const Usage = () => (
    <section>
        <div className="anchor-point" id="section-3" />
        <h1>Usage and contribution</h1>
        <hr/><br/>
        <p>
            The API is free to use with the limit of 3000 requests/day.
            If exceeds it will send the 429 status code.
        </p>
        <p>
            Feel free to make Pull Request if you like to add or correct content.
        </p>
        <br/>

        <h3>Error fix</h3>
        <div className="docs__order">
            <p>1. Open a new issue</p>
            <p>2. Assign yourself</p>
            <p>3. Include the issue number in the PR</p>
            <p>4. Make the Pull request</p>
        </div>
    </section>
)

export default Usage